import React from "react";

import "./EWPDivider.scss";

export const EWPDivider = () => <div className="divider" />;
